<template>
  <div>
    <BottomSheetModal ref="modal" :isModal="true" headerBg="#fff">
      <template #header>
        <div></div>
      </template>
      <div class="bg-white sticky top-0">
        <div class="text-2xl font-bold py-4">
          {{ $t('matches.upcomingMatchesTitle') }}
        </div>
      </div>

      <div class="flex flex-col gap-6 max-w-full w-[450px]">
        <div v-for="(match, i) in matches">
          <div class="flex justify-between">
            <div class="w-[40%] font-bold truncate">
              {{ match.team1 }}
            </div>
            <div class="text-description-color">vs</div>
            <div class="w-[40%] font-bold truncate text-right">
              {{ match.team2 }}
            </div>
          </div>
          <div class="flex justify-between items-center">
            <div class="w-[60%]">
              {{ $Commons.time(match.startTime, 'dddd DD MMM') }}
            </div>
            <div
              class="text-right bg-slate-100 p-1 px-3 inline-block rounded-full"
            >
              {{ $Commons.time(match.startTime, 'HH:mm') }}
            </div>
          </div>
        </div>
      </div>
    </BottomSheetModal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BottomSheetModal from '../utils/BottomSheetModal.vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

export default defineComponent({
  name: 'MatchList',
  components: {
    BottomSheetModal,
    AppDataProperty,
  },
  props: {},
  data() {
    return {
      reference: '',
      eventsIds: [],
      matches: [],
      appData: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('show_match_list', this.showMatchList)
    this.eventsIds.push(id)
    // this.test()
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showMatchList(matches) {
      this.matches = matches
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    test() {
      this.$Events.dispatchEvent('notification_action_click', {
        actionButtonIndex: 0,
        data: {
          actions: [{ matchList: true }],
          matches: [
            {
              id: '555195157',
              country: 'Europe',
              lastNotificationTime: '2024-09-18T15:24:49.348Z',
              league: 'UEFA Champions League',
              startTime: '2024-09-19T19:00:00.000Z',
              status: 'upcoming',
              team1: 'Atalanta',
              team2: 'Arsenal',
            },
          ],
        },
      })
    },
  },
})
</script>
